import React from 'react';
import PropTypes from 'prop-types';
import mapIconMapping from '../../utils/mapIconTitles';

import IconSchool from '../../assets/images/icons/IconSchool';
import IconKoopv from '../../assets/images/icons/IconKoopv';
import IconSchuleBeratungsstelle from '../../assets/images/icons/IconSchuleBeratungsstelle';
import IconLSJ from '../../assets/images/icons/IconLSJ';
import IconInstitution from '../../assets/images/icons/IconInstitution';
import IconInstitutionSehbehinderung from '../../assets/images/icons/IconInstitutionSehbehinderung';
import IconInstitutionSchulAufsicht from '../../assets/images/icons/IconInstitutionSchulAufsicht';
import IconInstitutionLandesinkluClearing from '../../assets/images/icons/IconInstitutionLandesinkluClearing';
import IconInstitutionServiceStelle from '../../assets/images/icons/IconInstitutionServiceStelle';
import IconInstitutionZKI from '../../assets/images/icons/IconInstitutionZKI';

import styles from './InnerIcon.module.scss';

const iconComponents = {
    IconSchool,
    IconKoopv,
    IconSchuleBeratungsstelle,
    IconLSJ,
    IconInstitution,
    IconInstitutionSehbehinderung,
    IconInstitutionSchulAufsicht,
    IconInstitutionLandesinkluClearing,
    IconInstitutionServiceStelle,
    IconInstitutionZKI,
};

const iconExtraProps = {
    IconInstitutionSehbehinderung: { stroke: '#000' },
    IconLSJ: { width: '36', height: '34' },
};

const InnerIcon = ({ className = '', icon }) => {
    const entry = mapIconMapping[icon];
    if (!entry) return null;

    const iconName = entry.icon;
    const IconComponent = iconComponents[iconName];
    if (!IconComponent) return null;

    const resolvedClassName =
        iconName === 'IconInstitutionLandesinkluClearing'
            ? [className, styles.clearing].join(' ')
            : className;

    return (
        <IconComponent
            className={resolvedClassName}
            {...(iconExtraProps[iconName] || {})}
        />
    );
};

InnerIcon.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string,
};

export default InnerIcon;
